import { BaseGraphqlLayer } from '@core/base';
import { ICreateCompletionGeminiInputType } from '@introspection/index';
import { Injectable } from '@rxdi/core';
import { map } from 'rxjs/operators';

@Injectable()
export class AiService extends BaseGraphqlLayer {
  createCompletion(payload: ICreateCompletionGeminiInputType) {
    return this.mutate({
      mutation: 'create-completion-gemini.mutation.graphql',
      variables: {
        payload,
      },
    }).pipe(map((res) => res.data.createCompletionGemini));
  }
}
